import BaseUpload from './BaseUpload';
export default BaseUpload;
//# sourceMappingURL=index.js.map
